import { render, staticRenderFns } from "./brandRetailerMenu.vue?vue&type=template&id=3ac67b08"
import script from "./brandRetailerMenu.vue?vue&type=script&lang=js"
export * from "./brandRetailerMenu.vue?vue&type=script&lang=js"
import style0 from "./brandRetailerMenu.vue?vue&type=style&index=0&id=3ac67b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports